import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CURRENCY_NAME, GOLD_BID_PRICE_CONST_KEY, PRODUCT_GOLD_TYPE } from "../../constants";
import { RoutesPaths } from "../../Router/constant";
import { userBidGoldPriceAction, userBidSilverPriceAction } from "../../actions/user";
import CurrencyFormat from "../currencyFormat/currencyFormat";
import { bidGoldHeaderCurrencyAction, bidSilverHeaderCurrencyAction } from "../../actions/stripe";
import { selectedPlanProductAction } from "../../actions/subscriptionPlan";
import Select, { components } from "react-select";
import { customStyles } from "../CustomSelect/CustomSelect";
import { isBrowser, isMobile } from 'react-device-detect';
import { SET_HAS_FETCHED_BID_PRICES } from "../../actions/types";


export default function GoldBid() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { bidGoldPrice, bidGoldHeaderCurrency, bidGoldHeader, bidSilverPrice, bidSilverHeader,hasFetched } = useSelector((state) => state.user);
  const goldHeaderArray = [
    GOLD_BID_PRICE_CONST_KEY.GOLD1KG,
    GOLD_BID_PRICE_CONST_KEY.GOLD1G,
    GOLD_BID_PRICE_CONST_KEY.SILVER10G,
    GOLD_BID_PRICE_CONST_KEY.SILVER1KG,
    GOLD_BID_PRICE_CONST_KEY.GOLD1OUNCE
  ];
  useEffect(() => {
    if (!hasFetched) {
      dispatch(userBidGoldPriceAction())
      dispatch(userBidSilverPriceAction())
      dispatch({ type: SET_HAS_FETCHED_BID_PRICES });
    }
  }, [])

  const handleStipePopupAction = (productKey) => {
    // if (location.pathname === RoutesPaths.BANKTRANSFER) {
    //   navigate(RoutesPaths.PAYMENT)
    // }

    const product = bidGoldPrice[productKey] || bidSilverPrice[productKey]
    if (Object.keys(product).length > 0) {
      dispatch(selectedPlanProductAction(product))
      // dispatch(paymentModalAction(true, product?.planType?.value));
      if (product?.slug) {
        navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", product?.slug));
      }
    }
  }

  const handleCurrencyChange = (event) => {
    let payload = {}
    for (const property in bidGoldPrice) {
      payload[property] = parseFloat(bidGoldPrice[property].price)
    }
    let silverpayload = {}
    for (const property in bidSilverPrice) {
      silverpayload[property] = parseFloat(bidSilverPrice[property].price)
    }
    dispatch(bidGoldHeaderCurrencyAction(event, payload))
    dispatch(bidSilverHeaderCurrencyAction(event, silverpayload))
  }

  const CaretDownIcon = () => {
    return <img src="assets/img/arrow_downIocn.svg" alt="" />;
  };

  // added type if using typescript
  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };
  return (
    <>
      <div className={`bid-gold-price gold-bid-holder w-100`}>
        <div className="gold-bid-price-holder custom-scroll">
          {Object.keys(bidGoldHeader).length > 0 && Object.entries(bidGoldHeader).map(([key, value]) => (
            goldHeaderArray.includes(key) && (
              <div className="bidCurrencyHolder" key={key} onClick={() => handleStipePopupAction(key)}>
                <p className="bidName">
                  {value?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM ? "Gold 1kg" : "Gold 1gram"}
                </p>
                <div className="bidName span chipIncDecOuter">
                  <p className="bidName span chipIncDecOuter">
                    {value?.currency?.name} <CurrencyFormat currency={value?.currency?.value} value={parseFloat(value?.price)} decimal={2} />
                  </p>
                  <div className={value?.inflation > 0 ? 'incressPrice' : 'decressPrice'}>
                    {(value?.inflation > 0 || value?.inflation < 0) &&
                      <img className="bidInflation" src={`assets/img/${value?.inflation >= 0 ? 'incressPrice' : 'decressPrice'}.svg`} alt="" />
                    }
                    <span className="chipIncDec">{value?.inflation}%</span>
                  </div>
                </div>
              </div>)
          ))}
          {Object.keys(bidSilverHeader).length > 0 && Object.entries(bidSilverHeader).map(([key, value]) => (
            goldHeaderArray.includes(key) && (
              <div className="bidCurrencyHolder" key={key} onClick={() => handleStipePopupAction(key)}>
                <p className="bidName">
                  {value?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM ? "Silver 1kg" : "Silver 1gram"}
                </p>
                <div className="bidName span chipIncDecOuter">
                  <p className="bidName span chipIncDecOuter">
                    {value?.currency?.name} <CurrencyFormat currency={value?.currency?.value} value={parseFloat(value?.price)} decimal={2} />
                  </p>
                  <div className={value?.inflation > 0 ? 'incressPrice' : 'decressPrice'}>
                    {(value?.inflation > 0 || value?.inflation < 0) &&
                      <img className="bidInflation" src={`assets/img/${value?.inflation >= 0 ? 'incressPrice' : 'decressPrice'}.svg`} alt="" />
                    }
                    <span className="chipIncDec">{value?.inflation}%</span>
                  </div>
                </div>
              </div>)
          ))}
        </div>
        {Object.keys(bidGoldHeader).length > 0 && (
          <div className="currencySelectBoxHolder">
            <form>
              <Select
                // theme={SELECT_BOX_THEME}
                components={{ DropdownIndicator }}
                styles={customStyles}
                className="select-border"
                options={CURRENCY_NAME}
                isClearable={false}
                isSearchable={false}
                getOptionLabel={(option) => (
                  <>
                    <img src={`assets/img/${option.value}.png`} alt={option.value} style={{ marginRight: 10, width: 20, height: 20 }} />
                    {option.value.toUpperCase()}
                  </>
                )}
                getOptionValue={(option) => option.value}
                onChange={handleCurrencyChange}
                defaultValue={bidGoldHeaderCurrency}
                placeholder="Select"
              />
            </form>
          </div>
        )}
      </div>
    </>
  );
}
